import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SliderComponent } from './slider.component';
import { FormsModule } from '@angular/forms';
import { WmInputModule } from '../input/index';

@NgModule({
	declarations: [SliderComponent],
	imports: [CommonModule, FormsModule, WmInputModule],
	exports: [SliderComponent]
})
export class WmSliderModule {}
